<template>
  <el-dialog
    append-to-body
    class="components-image-libs-wrapper"
    title="资源列表"
    :visible="true"
    @close="finishSelect(null)"
    :close-on-click-modal="false"
  >
    <div style="height: 500px; overflow: auto">
      <el-row type="flex" class="cont">
        <!-- 文件夹 -->
        <el-col :span="8">
          <el-tree :expand-on-click-node="false"
            node-key="folder_id"
            highlight-current	
            :data="folderList"
            :props="{ children: 'children', label: 'folder_name' }"
            @node-click="selectFolder"
          ></el-tree>
        </el-col>
        <!-- 文件 -->
        <el-col class="cont-file">
          <!-- 文件分类 -->
          <div class="category">
            <upload-file
              :autoClose="true"
              :suffix="suffix"
              :fileType="fileType"
              :openFolderList="[{ folder_id: folderId }]"
              @onSuccess="getFileList"
            >
              <el-button type="primary" slot="btn">上传文件</el-button>
            </upload-file>
          </div>

                  <!-- 文件内容 -->
                    <div  v-if="!fileList.length">

        <not-fund-data-vue></not-fund-data-vue>
                    </div>

        <div v-else>
          <div class="content" ref="content"   v-loading="isLoading">

            <div
              class="content-file"
              v-for="(file, idx) in fileList"
              :key="idx"
              @click="finishSelect(file)"
            >
            <div v-if="file.auth_status == 1" style="font-size: 12px;line-height: 1.4;color: red;position: absolute;top: 0;background: grey;color: white;z-index: 999;">
                审核中
            </div>
            <div v-else-if="file.auth_status == 3" style="font-size: 12px;line-height: 1.4;color: red;position: absolute;top: 0;background: goldenrod;color: white;z-index: 999;">
                疑似{{file.unauth_reason}}
            </div>
            <div v-else-if="file.auth_status == 4" style="font-size: 12px;line-height: 1.4;color: red;position: absolute;top: 0;background: red;color: white;z-index: 999;">
                违规:{{file.unauth_reason}}
            </div>
            
              <img
                v-if="file.file_type === 1"
                class="file-cover"
                :src="file.file_url"
                alt=""
              />
              <video 
                v-else-if="file.file_type === 2"
                class="file-cover"
                :src="file.file_url"
              ></video>
              <audio 
                class="file-cover"
                v-else-if="file.file_type === 3"
                :src="file.file_url"
              ></audio>
              <img
                v-else
                class="file-cover"
                :src="file.file_url"
                alt=""
              />
            </div>
          </div>


            <pagination style="position: sticky;bottom: 0; right: 0;width: 100%;background-color: white;"
              @sizeChange="sizeChange"
              @pageChange="pageChange"
              :total="totalNum"
              :page-count="searchParams.page"
              :page-size="searchParams.size">
            </pagination>
        </div>


        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import notFundDataVue from "./notFundData.vue";
import uploadFile from "./folder/upload-file.vue";
import pagination from "@/components/pagination/pagination"
export default {
  name: "file-selector",
  components: {
    notFundDataVue,
    uploadFile,
    pagination
  },
  props: {
    fileType: {
      type: [Number, String],
      default: "",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultImg: require("../common/images/program-cover-image.png"),
      uploading: false,
      hasLoadData: false,
      imageList: [],
      selectId: "",
      folderList: [],
      fileList: [],
      folderId: null,
      suffix: [],
      searchParams: {
        page: 1,
        size: 20,
      },
      totalNum: 0,
      isLoading:false
    };
  },
  mounted() {
    this.judegFileType();
    this.getFolderListAll();
    this.getFileList();
  },
  methods: {
    sizeChange(e){
      this.searchParams.size = e
      this.getFileList()
    },
    pageChange(e){
        console.log(e)
      this.searchParams.page = e
      this.getFileList()
    },
    judegFileType() {
      let fileSuffixDict = {
        image: {
          suffix: ["jpg", "png", "gif", "jpeg"],
          file_type: 1,
        },
        video: {
          suffix: ["mp4"],
          file_type: 2,
        },
        audio: {
          suffix: [
            "MP3",
            "WAV",
            "WMA",
            "MP2",
            "Flac",
            "MIDI",
            "RA",
            "APE",
            "AAC",
            "CDA",
            "MOV",
          ],
          file_type: 3,
        },
      };
      this.suffix = fileSuffixDict[this.fileType].suffix;
      this.file_type = fileSuffixDict[this.fileType].file_type;
    },
    selectFolder(node) {
        this.folderId = node.folder_id
        this.getFileList();
    },
    getFileList() {

      this.isLoading = true
      // 获取资源
      let data = {
        folder_id: this.folderId || null,
        file_type: this.file_type,
        ...this.searchParams,
      };
      this.$API.getFileList(data).then((res) => {
        this.fileList = res.data.list;
        let {page,size,total} = {...res.data.pagination}
        this.totalNum = total
        this.searchParams.page = page
        this.searchParams.size = size
        this.isLoading = false
      }).catch( ()=>{
        this.isLoading = false
      });
    },
    getFolderListAll() {
      // 获取所有文件夹
      this.$API.getFolderListAll().then((res) => {
        console.log(res.data, "所有资源文件夹");
        let folderList = res.data;
        folderList.forEach((ele) => {
          ele.children = [];
          if (ele.parent_folder_id) {
            for (let i = 0; i < folderList.length; i++) {
              if (folderList[i].folder_id === ele.parent_folder_id) {
                folderList[i].children.push(ele);
              }
            }
          }
        });
        folderList = folderList.filter((item) => {
          return !item.parent_folder_id;
        });
        this.folderList = [
          { folder_name: "我的资源", children: folderList, folder_id: null },
        ];
      });
    },
    beforeUpload(file) {
      if (file.size > 1 * 1024 * 1024) {
        this.$message.error("psd文件不能超过1M！");
        return;
      }
      let temp1 = file.name.split(".");
      let temp = temp1[temp1.length - 1];
      if (!["jpg", "png", "gif"].includes(temp)) {
        this.$message.error("请上传jpg/png/gif文件");
        return false;
      }
      this.uploadPsd(file);
      return false;
    },
    uploadPsd(file) {
      let params = new FormData();
      params.append("file", file);
      this.uploading = true;
      this.$API
        .uploadImage(params)
        .then((res) => {
          this.uploading = false;
          this.imageList.splice(0, 0, res.body);
        })
        .catch(() => {
          this.uploading = true;
        });
    },
    getMyImages() {
      this.hasLoadData = true;
      this.$API.getMyImages().then((res) => {
        this.imageList = res.body || [];
      });
    },
    finishSelect(fileInfo) {
      console.log('触发')
      this.$emit("finish", fileInfo);
    },
  },
};
</script>

<style lang="scss" scoped>
.image-list-wrapper {
  height: 400px;
  padding-top: 20px;
  .image-item {
    width: 120px;
    height: 120px;
    float: left;
    background: #eee 50% / contain no-repeat;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    display: flex;
    transition: all 0.28s;
    margin: 5px;
    &:hover {
      box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.16);
      transform: translate3d(0, -2px, 0);
    }
    img {
      display: inline-block;
      max-width: 100%;
      max-height: 100%;
    }
  }
}
.cont {
  height: 100%;

  ::v-deep .el-tree{
    .is-focusable{
      // background:#25A589;
    }
    .el-tree-node{
      .el-tree-node__content{
        height:40px;

      }
      .el-tree-node__content:hover{
        background:#EEEEEE;
        // color:#FFF;
      }
    }
    .el-tree-node:focus > .el-tree-node__content{
      background:#EEEEEE;
      // color:#FFF;

      }
  }
.cont-file {
    height: 100%;
    overflow: auto;
    border-left: 1px solid #ccc;
    position: relative;
    // padding-left:20px;
    .category {
      position: sticky;
      top: 0;
      background: #fff;
      display: flex;
      flex-wrap: nowrap;
      overflow: auto;
      padding: 0 10px 10px;
      margin-bottom: 20px;
      // box-shadow: 0px 2px 6px 2px #999;
      box-shadow: 0px 7px 13px -7px #5e5e5e;
      z-index: 1;
      .category-item {
        padding: 2px 6px;
        border: 1px solid #666;
        margin-right: 20px;
        border-radius: 2px;
      }
    }
    .content {
        display: grid;
        grid-template-columns: repeat(5, calc(20% - 10px));
        grid-row-gap: 10px;
        grid-column-gap:10px;
        width: 100%;
            overflow: auto;
    position: relative;
    height: calc(100% - 100px);

      .content-file {
        margin: 0 20px 20px 0;
        box-shadow: 0 0 10px #ccc;
        width: 100%;
        padding-top: 100%;
        height: 0;
        position: relative;
        cursor: pointer;
        video{
          pointer-events: none;
        }
        .file-cover {
          display: block;
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.components-image-libs-wrapper {
  .el-dialog__body {
    padding: 0 20px 20px;
  }
}
</style>
